// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__G+B-s","mainContent":"Layout_mainContent__FbaE5","contentBody":"Layout_contentBody__Sk0Hp"};